"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.UnavNoteSection = void 0;
const forms_1 = require("@app/component/ui/forms");
const form_grid_layout_1 = require("@app/component/ui/forms/form-grid-layout");
const util_1 = require("@app/util");
const react_1 = __importDefault(require("react"));
const unavailability_context_1 = require("../unavailability-context");
const modal_section_1 = require("./modal-section");
const UnavNoteSection = () => {
    const { formControl, isEmployeeCalendar, isEditing, canEdit } = (0, unavailability_context_1.useUnavailability)();
    const canManagerCalendarEdit = !isEmployeeCalendar && canEdit;
    return (react_1.default.createElement(modal_section_1.ModalSection, { id: 'note' },
        react_1.default.createElement(form_grid_layout_1.FormGridLayout, null,
            react_1.default.createElement(forms_1.TextInput, { testid: 'note-input', label: (0, util_1.t)('NOTE'), control: formControl, name: 'note', disabled: isEmployeeCalendar ? isEditing : !canManagerCalendarEdit }))));
};
exports.UnavNoteSection = UnavNoteSection;
